import { extend } from 'vee-validate';
import { validator } from './runtime';

extend('podcast_link', {
    ...validator,
    message: (field: string, params: Record<string, string>) => {
        return `Invalid ${field}. ${params[0].split('|')[1]}`;
    }
});
